import script from "./user-card.vue?vue&type=script&setup=true&lang=js"
export * from "./user-card.vue?vue&type=script&setup=true&lang=js"

import "./user-card.vue?vue&type=style&index=0&id=0fdc8178&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdc8178"]])

export default __exports__